export enum BrandingMode {
    Organization = 'organization',
    Flow = 'flow',
}
